import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Google
 * id AE294E7D-3AC0-4C7D-AFAF-8DDA0AB5BF52
 * name aspect-ratio
 * version: 2.6.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/aspect-ratio.svg
 * tags
 */
export const AspectRatioIcon = createSvgIcon(<><path d="M19,12H17V15H14V17H19V12M7,9H10V7H5V12H7V9M21,3H3A2,2 0 0,0 1,5V19A2,2 0 0,0 3,21H21A2,2 0 0,0 23,19V5A2,2 0 0,0 21,3M21,19H3V5H21V19Z" /></>, 'AspectRatioIcon');
export default AspectRatioIcon